<template>
    <div class="filter-search">
        <form action="" autocomplete="off">
            <button type="submit">
                <svg-icon icon="search" />
            </button>

            <button v-show="query" class="filter-remove" type="button" @click.prevent="clear">
                <span class="material-icons-round">close</span>
            </button>

            <input v-model="query" :placeholder="__('Find a patient')" name="search" type="text" />
        </form>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        reactive: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            query: this.value
        }
    },
    watch: {
        query() {
            this.$emit('input', this.query)
        }
    },
    methods: {
        async clear() {
            this.query = ''

            if (this.reactive) {
                return
            }

            await this.$nextTick()

            $(this.$el).find('form').submit()
        }
    }
}
</script>
